import React, {useEffect} from 'react';
import classes from './Page.module.scss';
import {createMarkup} from "../../shared/utility";
import {Col} from 'reactstrap';
import {Helmet} from "react-helmet";
import {sendVirtualPageView} from "../../shared/utility";
import SurveyHost from "../../containers/Survey/SurveyHost";

import {usePhases} from "../../shared/config";

const Page = ({pageTitle, survey, pageBody}) => {
    const votingPhases = usePhases();
    useEffect(() => {
        sendVirtualPageView(pageTitle);
    }, [pageTitle]);

    return (
        <React.Fragment>
            <Helmet>
                <title>{`${pageTitle} | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
            </Helmet>
            {survey === "top" && (votingPhases.appStatus === 'FINALE' || votingPhases.appStatus === 'CLOSED') &&
                <Col className="my-3" xs={12}>
                    <SurveyHost/>
                </Col>
            }
            <Col className="my-3" xs={12}>
                <article id="page-content"><h1>{pageTitle}</h1>
                    <div dangerouslySetInnerHTML={createMarkup(pageBody)} className={classes.Page}/>
                </article>
            </Col>
            {survey === "bottom" && (votingPhases.appStatus === 'FINALE' || votingPhases.appStatus === 'CLOSED') &&
                <Col className="my-3" xs={12}>
                    <SurveyHost/>
                </Col>
            }
        </React.Fragment>
    );
};

export default Page;
